export const NEW = "NEW";
export const IN_VERIFICATION = "IN_VERIFICATION";
export const CONFIRMED = "CONFIRMED";
export const IN_PROGRESS = "IN_PROGRESS";
export const UNCONFIRMED = "UNCONFIRMED";
export const RESOLVED = "RESOLVED";
